import scorecardStructureForm from './scorecard-structure/scorecard-structure-form'
import scorecardStructureResults from './scorecard-structure/scorecard-structure-results'
import scorecardStructureModel from './scorecard-structure/scorecard-structure-model'
import annualMetricDataForm from './annual-metric-data/annual-metric-data-form'
import annualMetricDataResults from './annual-metric-data/annual-metric-data-results'
import annualMetricDataModel from './annual-metric-data/annual-metric-data-model'
import sqlConsoleForm from './sql-console/sql-console-form'
import sqlConsoleResults from 'scoreboard/components/sql-console/sql-console-results'
import sqlConsoleModel from 'scoreboard/components/sql-console/sql-console-model'
import datasetReportForm from './dataset-report/dataset-report-form'
import datasetReportResults from './dataset-report/dataset-report-results'
import datasetReportModel from './dataset-report/dataset-report-model'
import initiativeReportForm from './initiative-report/initiative-report-form'
import initiativeReportResults from './initiative-report/initiative-report-results'
import initiativeReportModel from './initiative-report/initiative-report-model'
import scorecardReportForm from './scorecard-report/scorecard-report-form'
import scorecardReportResults from './scorecard-report/scorecard-report-results'
import scorecardReportModel from './scorecard-report/scorecard-report-model'

var ReportsMeta = {
	'scorecard-structure': {
		'results': scorecardStructureResults,
		'form': scorecardStructureForm,
		'model': scorecardStructureModel
	},
	'annual-metric-data': {
		'results': annualMetricDataResults,
		'form': annualMetricDataForm,
		'model': annualMetricDataModel
	},
	'sql-console': {
		'results': sqlConsoleResults,
		'form': sqlConsoleForm,
		'model': sqlConsoleModel
	},
	'dataset-report-designer' : {
		'results': datasetReportResults,
		'form': datasetReportForm,
		'model': datasetReportModel
	},
	'initiative-report-designer' : {
		'results': initiativeReportResults,
		'form': initiativeReportForm,
		'model': initiativeReportModel
	},
	'scorecard-report-designer' : {
		'results': scorecardReportResults,
		'form': scorecardReportForm,
		'model': scorecardReportModel
	}

}

export default ReportsMeta

ReportsMeta.__filename__ = 'reports/reports-meta.js'
